module.exports = __webpack_public_path__ + "img/USI_logo.0730aeba.png";